module.exports = __webpack_public_path__ + "static/img/nature-barCode.2ca898de.png";